import { render, staticRenderFns } from "./date.vue?vue&type=template&id=1345d812&scoped=true&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"
import style0 from "./date.vue?vue&type=style&index=0&id=1345d812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345d812",
  null
  
)

component.options.__file = "date.vue"
export default component.exports